document.addEventListener("DOMContentLoaded", () => {
  const remotes = document.getElementsByName('remote-product');
  const remoteSelect = document.querySelector(".remote-select");
  const remoteSelectBtn = document.querySelector(".remote-select .select-button");
  const selectedRemoteValue = document.querySelector(".remote-select .selected-value");
  const remoteOptionsList = document.querySelectorAll(".remote-select .select-dropdown li");
  const cartBtn = document.querySelector('.product-form__submit');
  const cartBtnText = cartBtn.querySelector('span');
  const cartBtnPrice = cartBtn.querySelector('.product-form__cart-submit-price');

  // Check preselected remote
  remotes.forEach((remote)=>{
      if (remote.checked) {
          selectedRemoteValue.innerHTML = `${remote.dataset.price} - ${remote.dataset.sku}`;
          // Find and mark the label as active
          remoteOptionsList.forEach((option) => {
              const checkbox = option.querySelector('input[type="checkbox"]');
              const label = option.querySelector('.acc-label');
              if (checkbox && checkbox.id === remote.id && label) {
                  label.classList.add('active');
              }
          });
      }
  })

  remoteSelectBtn.addEventListener("click", () => {
      remoteSelect.classList.toggle("active");
      remoteSelectBtn.setAttribute(
        "aria-expanded",
        remoteSelectBtn.getAttribute("aria-expanded") === "true" ? "false" : "true"
      );
  });
    document.addEventListener("click", (event) => {
  const isClickInside = remoteSelect.contains(event.target) || remoteSelectBtn.contains(event.target);

  if (!isClickInside) {
    remoteSelect.classList.remove("active");
    remoteSelectBtn.setAttribute("aria-expanded", "false");
  }
});
  
  remoteOptionsList.forEach((option) => {
      function handler(e) {
        if (e.type === "click" && e.clientX !== 0 && e.clientY !== 0) {
          const checkbox = this.children[0];
          const label = this.children[1];
          
          // Prevent unchecking if this is the currently selected remote
          // Force selection of a different remote instead of allowing deselection
          if (checkbox.checked) {
            // Don't allow unchecking - keep it selected
            e.preventDefault();
            return;
          }
          
          // Uncheck all other remotes first
          remotes.forEach((remote) => {
            remote.checked = false;
          });
          
          // Check the clicked remote
          checkbox.checked = true;
          
          // Remove active class from all labels
          remoteOptionsList.forEach((opt) => {
            if (opt.children[1]) {
              opt.children[1].classList.remove('active');
            }
          });
          
          // Add active class to current label
          label.classList.add('active');
          
          // Update the displayed value
          const price = checkbox.dataset.price;
          const sku = checkbox.dataset.sku;
          selectedRemoteValue.innerHTML = `${price} - ${sku}`;
          
          remoteSelect.classList.remove("active");
          
          // Trigger change event to update the form
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
        // Key Events
        if (e.key === "Enter") {
          const checkbox = this.children[0];
          if (!checkbox.checked) {
            // Uncheck all others and check this one
            remotes.forEach((remote) => {
              remote.checked = false;
            });
            checkbox.checked = true;
            
            // Update active classes
            remoteOptionsList.forEach((opt) => {
              if (opt.children[1]) {
                opt.children[1].classList.remove('active');
              }
            });
            this.children[1].classList.add('active');
            
            selectedRemoteValue.innerHTML = `${checkbox.dataset.price} - ${checkbox.dataset.sku}`;
          }
          remoteSelect.classList.remove("active");
        }
      }
  
      option.addEventListener("keyup", handler);
      option.addEventListener("click", handler);
  });

  const qtyInput = document.querySelector('.quantity__input');
  const upselQuantity = document.querySelector('.single-variant-qty');
  const plusButton = document.querySelector(".quantity__button[name='plus']");

  qtyInput.addEventListener('input', function(e) {
      const controlboxes = document.getElementsByName('controlbox');
     
      controlboxes.forEach((cbox)=> {
        cbox.disabled = true;
        cbox.checked = false;
      })

      let qtyValue = parseFloat(qtyInput.value);

      let selectedUpsellVal =  parseFloat(upselQuantity.value);
      if (selectedUpsellVal > (qtyValue * 2)) {
        selectedUpsellVal = qtyValue * 2;
        document.querySelector('.acc-qty-selector').reset();
      }
      upselQuantity.max = qtyValue * 2;

      if (qtyValue == 4 || qtyValue == '4') {
        plusButton.disabled = true;
      } else {
        plusButton.disabled = false;
      }

      const fltcon_1 = document.querySelector('[data-sku="FLTCON-1"]');
      const fltcon_2 = document.querySelector('[data-sku="FLTCON-2"]');
      const fltcon_2_24 = document.querySelector('[data-sku="FLTCON-2-24VDC"]');
      const fltcon_3 = document.querySelector('[data-sku="FLTCON-3"]');
      const fltcon_4 = document.querySelector('[data-sku="FLTCON-4"]');

      switch (qtyValue) {
        case 1:
          fltcon_1.disabled = false;
          break;
        case 2:
          fltcon_2.disabled = false;
          fltcon_2_24.disabled = false;
          break;
        case 3:
          fltcon_3.disabled = false;
          break;
        case 4:
          fltcon_4.disabled = false;
          break;
        default:
          fltcon_4.disabled = false;
          break;
      }

      // Trigger validation when quantity changes
      const columnBuilder = document.querySelector('columnset-selection');
      if (columnBuilder) {
          columnBuilder.validateControlBox();
      }
  })

  let selectedVarObj = null;
  let selectedVariantId = null;
  let selectedControl = null;
  let selectedRemote = null;
  let selectedQty = parseFloat(qtyInput.value);
  let bundleAr = [];
  let upsellAr = [];

  class ColumnBuilder extends HTMLElement {
      constructor() {
        super();

        this.addEventListener("click", this.onBuilderChange);
        this.cartBtn = document.querySelector(".product-form__submit");
        
        // Initialize variant data and selection first
        this.getVariantData();
        this.updateOptions();
        

        
        // Initial validation on load
        setTimeout(() => {
            this.validateControlBox();
        }, 100);

        this.cartBtn.addEventListener("click", (e) => {
          e.preventDefault();

          // Check control box selection
          if (!selectedControl) {
            const selectedCBError = document.querySelector(".error-selection");
            selectedCBError.innerHTML = `Select Control Box`;
            setTimeout(() => (selectedCBError.innerHTML = ""), 3000);
            return;
          }

          if (bundleAr.length < 3) {
            return;
          }

          const request = JSON.parse(JSON.stringify(bundleAr));
          const cartData = request.map((r) => ({
            id: r.id,
            quantity: r.quantity,
            properties: r.properties,
          }));

          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          const formData = {};
          formData.items = cartData;
          config.body = JSON.stringify(formData);

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.cartBtn.setAttribute("aria-disabled", true);
                this.cartBtn.querySelector("span").classList.add("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
            })
            .catch((e) => {
              console.log(e);
            })
            .finally(() => {
              this.cartBtn.classList.remove("loading");
              if (!this.error) this.cartBtn.removeAttribute("aria-disabled");
            });
        });

        // Update price and images after initialization
        setTimeout(() => {
          if (selectedVarObj) {
            this.updatePriceBundle();
            this.updateUpselImages();
          } else {
            console.error('selectedVarObj still not set after initialization');
          }
        }, 200);
      }

      validateControlBox() {
        const controlboxes = document.getElementsByName('controlbox');
        const cartBtn = document.querySelector(".product-form__submit");
        const cartBtnText = cartBtn.querySelector('span');
        const selectedCBError = document.querySelector(".error-selection");
        
        // Check if selectedVarObj exists
        if (!selectedVarObj) {
          console.warn('validateControlBox called but selectedVarObj is undefined');
          cartBtnText.innerHTML = `Select Control Box`;
          cartBtn.disabled = true;
          return;
        }
        
        let isControlBoxSelected = false;
        controlboxes.forEach((cbox) => {
          if (cbox.checked) {
            isControlBoxSelected = true;
          }
        });

        if (!isControlBoxSelected) {
          cartBtnText.innerHTML = `Select Control Box`;
          cartBtn.disabled = true;
          if (selectedCBError) {
            selectedCBError.innerHTML = `Select Control Box`;
          }
        } else {
          const variantInventory = +selectedVarObj.inventory_quantity;
          const quantity = document.querySelector(".quantity__input");
          const selectedQty = parseFloat(quantity.value);
          
          if (selectedQty > variantInventory) {
            cartBtnText.innerHTML = window.variantStrings.pre_order;
          } else {
            cartBtnText.innerHTML = window.variantStrings.addToCart;
          }
          cartBtn.disabled = false;
          if (selectedCBError) {
            selectedCBError.innerHTML = "";
          }
        }
      }

      onBuilderChange() {
        this.updateOptions();
        this.getVariantData();
        
        // Don't proceed if no variant is selected
        if (!selectedVarObj) {
          console.warn('No variant selected, skipping update');
          return;
        }
        
        this.getCurrentQty();
        this.getControl();
        this.getRemote();
        this.updateUpselImages();
        this.getUpsell();
        this.arrayCreate();
        this.updatePriceBundle();
        this.onRenderChange();
        this.validateControlBox();
      }

      getVariantData() {
        const jsonElement = this.querySelector('[type="application/json"]');

        
        if (!jsonElement) {
          console.error('No JSON element found in columnset-selection');
          return [];
        }
        
        this.variantData =
          this.variantData ||
          JSON.parse(jsonElement.textContent);
        
        return this.variantData;
      }

      updateOptions() {
        this.options = Array.from(
          this.querySelectorAll(".variant-picker input"),
          (select) => select.value
        );
        
        // Handle products without options (only default variant)
        const variantInputs = Array.from(
          this.querySelectorAll(".variant-picker input")
        );
        
        const variantData = this.getVariantData();
        
        if (variantInputs.length === 0) {
          // Product has no options, use first available variant
          this.currentVariant = variantData[0];
          console.log('No variant inputs found, using first variant:', this.currentVariant);
        } else {
          const checkedInput = variantInputs.find((radio) => radio.checked);
          const checkedValue = checkedInput ? checkedInput.value : null;
          console.log('checkedValue:', checkedValue);
          
          this.currentVariant = variantData.find((variant) => {
            return variant.options[0] == checkedValue;
          });
          console.log('Found variant by option:', this.currentVariant);
        }

        selectedVarObj = this.currentVariant;
        console.log('selectedVarObj set to:', selectedVarObj);
        return selectedVarObj;
      }

      updateUpselImages() {
        const checkboxUpselImages = document.querySelectorAll('.color-checkbox-image'),
              upselVariants = document.getElementsByName("checkbox-upsell"),
              defImage = document.querySelector('.def-image');
        let current;
        let isChecked = false;

        if(!defImage) {
          return;
        }

        upselVariants.forEach(variant => {
          if (variant.checked) {
            current = variant.value;
            isChecked = true;
            defImage.classList.add('hide');
          }
        })
        checkboxUpselImages.forEach(image => {
          image.classList.add('hide');
          if (image.getAttribute('data-variant') == current) {
            image.classList.remove('hide');
          }
        });
        if(!isChecked) {
          defImage.classList.remove('hide');
        }
      }

      updatePriceBundle() {
        const quantity = document.querySelector(".quantity__input");
        if (!quantity) {
          console.error('Quantity input not found');
          return;
        }
        
        selectedQty = parseFloat(quantity.value);

        const priceContainer = document.querySelector(".bundle-price");
        if (!priceContainer) {
          console.error('Price container not found');
          return;
        }
        
        // Ensure selectedVarObj is set
        if (!selectedVarObj) {
          const variantData = this.getVariantData();
          if (variantData && variantData.length > 0) {
            selectedVarObj = variantData[0];
            console.log('updatePriceBundle: Set selectedVarObj to first variant:', selectedVarObj);
          } else {
            console.error('No variant data available');
            return;
          }
        }
        
        // Double check selectedVarObj has required properties
        if (!selectedVarObj || !selectedVarObj.price) {
          console.error('Invalid variant object:', selectedVarObj);
          return;
        }
        
        console.log('Calculating price with selectedVarObj:', selectedVarObj);
        
        let variantPrice = parseFloat(selectedVarObj.price);
        selectedVariantId = selectedVarObj.id;
        let columnsPrice = variantPrice * selectedQty;
        let totalSumm = columnsPrice;

        // ControlBoxes
        let controlBoxPrice = 0;
        const controlboxes = document.getElementsByName("controlbox");
        controlboxes.forEach((box) => {
          if (box.checked) {
            controlBoxPrice = parseFloat(box.dataset.price);
          }
        });
        
        // Remotes
        let remotePrice = 0;
        const remotes = document.getElementsByName("remote-product");
        remotes.forEach((remote) => {
          if (remote.checked) {
            remotePrice = parseFloat(remote.dataset.pricewm);
          }
        });
        
        //Upsells
        let upselPrice = 0;
        if (upsellAr.length) {
          upsellAr.forEach(({upsellQtyt, price}) => {
            upselPrice += upsellQtyt * price;
          })
        }

        totalSumm = columnsPrice + controlBoxPrice + remotePrice + upselPrice;
        console.log('Total price:', totalSumm, 'Format:', window.moneyFormat);
        priceContainer.innerHTML = formatMoney(totalSumm, window.moneyFormat);

        if(cartBtnPrice) {
         cartBtnPrice.innerHTML = formatMoney(totalSumm, window.moneyFormat);
        }
      }

      getCurrentQty() {
        qtyInput.addEventListener("input", (e) => {
          const value = +qtyInput.value;
          if (value > 4) {
            qtyInput.value = 4;
          } else if (value < 1) {
            qtyInput.value = 1;
          }
        });
        selectedQty = parseFloat(qtyInput.value);
        return selectedQty;
      }

      getControl() {
        selectedControl = null;

        const remotes = document.getElementsByName("remote-product");
        let controlSku = null;

        const controlboxes = document.getElementsByName("controlbox");
        const selectedCBox = document.querySelector(".upsel_selected_value");
        selectedCBox.innerHTML = "";
        controlboxes.forEach((input) => {
          if (input.checked) {
            selectedControl = input.id;
            selectedCBox.innerHTML = input.dataset.sku;
            controlSku = input.dataset.sku;
          }
        });

        const btupsell = document.querySelector('input[name="column-upsell"][data-sku="RT-BT1"]');
        const btMsg = document.querySelector('.compatible-msg[data-sku="RT-BT1"]');
        const message = 'Not compatible with selected control box!'

        if(btupsell && selectedControl) {
          if(controlSku && (controlSku == 'FLTCON-1' || controlSku == 'FLTCON-2' || controlSku == 'FLTCON-4')) {
            if(btupsell.disabled) btupsell.disabled = false;
            btMsg.innerHTML = "";
          } else {
            if(btupsell.checked) btupsell.checked = false;
            btupsell.disabled = true;
            btMsg.innerHTML = message;
          }
        }

        return selectedControl;
      }

      getRemote() {
        selectedRemote = null;
        const remotes = document.getElementsByName("remote-product");
        remotes.forEach((remote) => {
          if (remote.checked) {
            selectedRemote = remote.id;
          }
          return selectedRemote;
        });
      }

      getUpsell() {
        const oneVariantUpsels = document.getElementsByName("column-upsell");
        const multiVariantUpsels = document.getElementsByName("checkbox-upsell");
        const selectVariantUpsels = document.getElementsByName("select-upsell");
        const mainColorCheckbox = document.querySelector('#main-checkbox-upsell');
        upsellAr = [];

        if (oneVariantUpsels.length) {
          oneVariantUpsels.forEach(elem => {
            if (elem.checked) {
              const obj = {};
              const currentVariant = elem.value;
              const currentUpsellSelect = document.getElementById(`select-${currentVariant}`);
              const currentUpselVal = currentUpsellSelect.value;

              obj.upsellVariant = currentVariant;
              obj.upsellQtyt = currentUpselVal;
              obj.price = +elem.getAttribute('data-price');

              upsellAr.push(obj);
            };
          })
        }

        if (multiVariantUpsels.length && mainColorCheckbox.checked) {
          multiVariantUpsels.forEach(elem => {
            if (elem.checked) {
              const obj = {};
              const currentVariant = elem.value;
              const currentProduct = elem.getAttribute('data-product-id');

              const qtySelector = document.getElementById(`select-${currentProduct}`);
              const currentUpselVal = qtySelector.value;

              obj.upsellVariant = currentVariant;
              obj.upsellQtyt = currentUpselVal;
              obj.price = +elem.getAttribute('data-price');

              upsellAr.push(obj);
            };
          })
        }

        if (selectVariantUpsels.length) {
          selectVariantUpsels.forEach(elem => {
            const obj = {};
            const currentVariant = elem.value;
            const currentProduct = elem.getAttribute('data-product-id');

            if (+currentVariant === 0) {
              return;
            } else {
              const qtySelector = document.getElementById(`select-${currentProduct}`);
              const currentUpselVal = qtySelector.value;

              obj.upsellVariant = currentVariant;
              obj.upsellQtyt = currentUpselVal;
              obj.price = +elem.getAttribute('data-price');

              upsellAr.push(obj);
            }
          })
        }
        
        return upsellAr;
      }

      arrayCreate() {
        bundleAr = [];

        const volumeWr = document.querySelector("columnset-selection");
        const volume_min7 = volumeWr.dataset.volume7;
        const volume_min10 = volumeWr.dataset.volume10;
        const volume_min20 = volumeWr.dataset.volume20;
        const columnSetId = `column-set_${Date.now()}`;

        if (selectedControl && selectedRemote && selectedVarObj && selectedVarObj.id) {
          if (selectedVarObj.id) {
            let arrayvariant = selectedVarObj.id.toString();
            bundleAr.push({
              id: arrayvariant,
              quantity: selectedQty,
              properties: {
                _column_set: columnSetId,
                _type: "column",
                _bundleColumnQty: selectedQty,
                _discount_min7: volume_min7,
                _discount_min10: volume_min10,
                _discount_min20: volume_min20,
              },
            });
          }
          if (selectedControl) {
            bundleAr.push({
              id: selectedControl,
              quantity: 1,
              properties: {
                _column_set: columnSetId,
                _bundleControlQty: 1,
                _type: "controlbox",
              },
            });
          }

          if (selectedRemote) {
            bundleAr.push({
              id: selectedRemote,
              quantity: 1,
              properties: {
                _column_set: columnSetId,
                _bundleRemoteQty: 1,
                _type: "remote",
              },
            });
          }

          if (upsellAr.length) {
            upsellAr.forEach(({upsellVariant, upsellQtyt}) => {
              bundleAr.push({
                id: upsellVariant,
                quantity: upsellQtyt,
                properties: {
                  _column_set: columnSetId,
                  _bundleUpsQty: upsellQtyt,
                  _type: "upsell",
                },
              });
            })
          }

          console.table(bundleAr);
          console.log('bundleAr contents:', bundleAr);
        } else {
          bundleAr = [];
          console.log('bundle is empty');
          return;
        }
        return bundleAr;
      }

      onRenderChange() {
        // Don't proceed if no variant is selected
        if (!selectedVarObj) {
          return;
        }
        
        const mediaGalleries = document.querySelectorAll("media-gallery");
        const liveRegion = document.querySelector('[id^="GalleryStatus"]');
        const viewer = document.querySelector('[id^="GalleryViewer"]');
        const thumbnails = document.querySelector(
          '[id^="GalleryThumbnails"]'
        );
        const qtyInput = document.querySelector(".quantity__input");
        let value = parseFloat(qtyInput.value);

        let currentOption = selectedVarObj.option1;
        let dataValue = `${currentOption}-${value}`;

        mediaGalleries.forEach((mediaGallery) =>
          mediaGallery.setActiveMedia(dataValue, true, true)
        );
      }
    }
    customElements.define('columnset-selection', ColumnBuilder);

    const variantPicker = document.querySelector('.variant-picker');
    variantPicker.addEventListener('change', (e)=> {
      const controlboxes = document.getElementsByName('controlbox');
      controlboxes.forEach((cbox)=> {
        cbox.disabled = true;
        cbox.checked = false;
      })
      // Only reset quantity if we're not restoring a bundle configuration
      const isRestoring = sessionStorage.getItem('restoreBundleConfig') || sessionStorage.getItem('bundleRestoreInProgress');
      if (!isRestoring) {
        qtyInput.value = 1;
        document.querySelector('.quantity__input').value = 1;
      }
      const fltcon_1 = document.querySelector('[data-sku="FLTCON-1"]');
      fltcon_1.disabled = false;

      let remotePrice = 0; 
      const remotes = document.getElementsByName('remote-product');
      remotes.forEach((remote) => {
        if(remote.checked) {
          remotePrice = parseFloat(remote.dataset.pricewm);
        }
      })
      const priceContainer = document.querySelector('.bundle-price');
      let updatedPrice = selectedVarObj.price + remotePrice;
      priceContainer.innerHTML = formatMoney(updatedPrice, window.moneyFormat);

      if(cartBtnPrice) {
        cartBtnPrice.innerHTML = formatMoney(updatedPrice, window.moneyFormat);
      }
      const plusButton = document.querySelector(".quantity__button[name='plus']");
      plusButton.disabled = false;

      // Trigger validation when variant changes
      const columnBuilder = document.querySelector('columnset-selection');
      if (columnBuilder) {
          columnBuilder.validateControlBox();
      }
    })
})